/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'
import type { GetRequestJobsChangesByJobUuidParams, HTTPValidationErrorDTO } from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * It extracts and returns changes occurred since the given file event id.

 * @summary Get Changes
 */
export const getRequestJobsChangesByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/changes`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsChangesByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsChangesByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/changes`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsChangesByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsChangesByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>> = ({
        signal,
    }) => getRequestJobsChangesByJobUuid(jobUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!jobUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsChangesByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>
>
export type GetRequestJobsChangesByJobUuidQueryError = ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsChangesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsChangesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsChangesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Changes
 */

export function useGetRequestJobsChangesByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsChangesByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsChangesByJobUuidQueryOptions(jobUuid, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}
